import { NgClass } from '@angular/common';
import { AfterViewInit, Component, Input, OnChanges, OnDestroy } from '@angular/core';

import { ContentLink, DynamicHtmlDirective, PlainLinkComponent } from '@frontend/vanilla/core';
import { LoyaltyLoginService } from '@frontend/vanilla/features/loyalty-login';
import { OfferButtonComponent } from '@frontend/vanilla/features/offer-button';
import { Subject, takeUntil } from 'rxjs';

import { Offer } from '../../offers/models';
import { LoadOffersApiService } from '../../offers/offers-service/load-offers.service';
import { OfferTypeBadgeComponent } from '../../shared-offers/offer-type-badge/offer-type-badge.component';
import { TrackingModelService } from '../../tracking/tracking-model-service';
import { BetStationConfiguration } from '../bet-station-client-config';
import { BetstationOfferService } from '../bet-station-offer.service';
import { BetstationOverlayDialogModal } from '../bet-station-overlay-dialog-modal';

@Component({
    selector: 'bet-station-offer-tile-teaser',
    templateUrl: 'bet-station-offer-tile-teaser.component.html',
    imports: [OfferTypeBadgeComponent, NgClass, DynamicHtmlDirective, OfferButtonComponent, PlainLinkComponent],
})
export class BetStationOfferTileTeaserComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() offer: Offer;
    @Input() teaserNumber: number;
    moreInfoCta: ContentLink;
    clientContentMessages: { [attr: string]: string };
    isSpecialOfferOptin: boolean = false;
    optInMessage: string = '';
    optedInMessage: string = '';
    optinExpiredMessage: string = '';
    optinInvalidMessage: string = '';
    optinUserNotEligibleMessage: string = '';
    specialOfferQueryparam: string = '';

    private readonly destroy$ = new Subject<void>();

    constructor(
        private trackingModelService: TrackingModelService,
        public betStationConfiguration: BetStationConfiguration,
        public loadOffersApiService: LoadOffersApiService,
        private betStationOfferService: BetstationOfferService,
        private loyaltyLoginService: LoyaltyLoginService,
        private overlayDialogModal: BetstationOverlayDialogModal,
    ) {
        this.loadClientContent();
    }

    get Special_offer_Id() {
        return this.offer.offerContent?.primaryCta?.attributes != null ? this.offer.offerContent?.primaryCta?.attributes['data-offer-id'] : null;
    }
    get Special_offer_Type() {
        return this.offer.offerContent?.primaryCta?.attributes != null ? this.offer.offerContent?.primaryCta?.attributes['data-offer-type'] : null;
    }

    ngOnChanges() {
        if (this.offer?.offerContent?.moreInfoCta?.url) {
            this.moreInfoCta = this.offer?.offerContent?.moreInfoCta;
        }
        this.isSpecialOfferOptin = this.offer?.offerMetadata?.isSpecialOfferOptin;
    }

    ngAfterViewInit() {
        this.loyaltyLoginService.loyaltyLoginValidation.subscribe((res: any) => {
            if (res != null && Object.keys(res)?.length > 0) {
                this.betStationOfferService.generateUrl(res, this.offer);
            }
        });
    }

    loadClientContent() {
        this.loadOffersApiService.clientContentMessages$.pipe(takeUntil(this.destroy$)).subscribe((messages: { [attr: string]: string }) => {
            if (messages) {
                this.clientContentMessages = messages;
                this.optInMessage = this.clientContentMessages['OptIn'] ?? '';
                this.optedInMessage = this.clientContentMessages['Opted_In'] ?? '';
                this.optinExpiredMessage = this.clientContentMessages['Optin_Expired'] ?? '';
                this.optinInvalidMessage = this.clientContentMessages['Optin_Invalid'] ?? '';
                this.optinUserNotEligibleMessage = this.clientContentMessages['Optin_User_Not_Eligible'] ?? '';
            }
        });
    }

    trackBetStationClick(positionEvent: string, position: any, cta: ContentLink) {
        this.trackingModelService.submitTracking({
            CategoryEvent: 'promotions',
            LabelEvent: 'bet station offers',
            ActionEvent: 'click',
            PositionEvent: this.offer?.offerMetadata?.applicableProducts?.join('|'),
            LocationEvent: this.offer?.offerContent?.title,
            EventDetails: positionEvent,
            URLClicked: cta?.url,
            contentPosition: position,
        });
    }

    navigateToOfferMoreInfo() {
        const requiredModalData = this.betStationOfferService.navigateToOfferMoreInfo(this.teaserNumber, this.offer);
        this.overlayDialogModal.openDialogModal(requiredModalData);
    }

    specialOffer_Click(evt: any) {
        this.trackBetStationClick('opt-in', this.teaserNumber, this.offer?.offerContent?.moreInfoCta);
        if (evt?.currentTarget?.attributes['data-offer-status']?.value !== 'offered') {
            this.navigateToOfferMoreInfo();
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
